import { Link } from "react-router-dom"; // Add this at the top

function Footer() {
  return (
    <footer className="border-t mt-10 p-4 w-full text-sm text-gray-700 flex flex-col md:flex-row justify-between items-center">
      <div className="flex gap-4 mb-2 md:mb-0">
	    <Link to="/about" className="hover:underline font-medium">About Us</Link>
        <Link to="/privacy" className="hover:underline font-medium">Privacy Policy</Link>
		<Link to="/contact" className="hover:underline font-medium">Contact Us</Link>
		<Link to="/terms" className="hover:underline font-medium">Terms Of Service</Link>
      </div>
      <div className="text-center md:text-right">
        2025 SA Technologies Inc © All rights reserved
      </div>
    </footer>
  );
}

export default Footer;
